module.exports = __webpack_public_path__ + "30a274cd01b6eeb0b082c918b0697f1e.woff2";